var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"emotion-icon",class:[_vm.iconClass],on:{"click":_vm.onIconClicked}})
}
var staticRenderFns = []

export { render, staticRenderFns }